import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Expert } from '../expert-card/expert-card';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-expert-profile-contact',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './expert-profile-contact.html',
  styleUrl: './expert-profile-contact.scss',
})
export class ExpertProfileContactComponent {
  @Input({ required: true }) expert!: Expert;
}
